import * as bannerStyles from '../../styles/internal-page/banner.module.scss';

import PropTypes from 'prop-types';
import React from 'react';
import {toExternalUrl} from '../../utils/utils';
import PolyLink from '../shared/PolyLink';

const Banner = ({
  elem,
}) => {
  const {
    button,
    bannerContent,
    action_target,
    title,
    open_new_window
  } = elem || {};

  return (
    <div className={bannerStyles.main}>
      <div className={bannerStyles.rootTitle}>
        <div>
          <h2 className={bannerStyles.title}>{title}</h2>
        </div>
        <div className={bannerStyles.margin}>
          <p className={bannerStyles.subtitle}>{bannerContent}</p>
        </div>
      </div>
      <div className={bannerStyles.button}>
        <PolyLink
          ariaLabel={button}
          className={bannerStyles.buttonLink}
          style={{padding: '10px'}}
          tabIndex={0}
          target={open_new_window ? '_blank' : '_self'}
          url={toExternalUrl(action_target)}
        >
          <p className={bannerStyles.typobutton}>
            {button}
          </p>
        </PolyLink>
      </div>
    </div>
  );
};

Banner.propTypes = {
  elem: PropTypes.shape({
    bannerContent: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    action_target: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  })
};

export default Banner;
